module.exports = __webpack_public_path__ + "img/bcc120.4d18c4ca.jpeg";